import React from "react";

import {
  useAddEveryoneToResourceGroup,
  useAddResourceToResourceGroup,
  useProjectResourcesRetrieval,
  useRemoveResourceFromResourceGroup,
} from "@planzone/view-models";
import { Identifiable, ProjectResource } from "@planzone/dto";
import { AddMemberIcon } from "../addMemberIcon";
import { SelectList } from "@common/selectList";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectResourceSelect({
  project,
  projectResources: groupMembers,
  group,
}: Props) {
  const { projectResources } = useProjectResourcesRetrieval(project);
  const { addResourceToResourceGroup } = useAddResourceToResourceGroup(group, {
    uuid: "",
  });
  const { removeResourceFromResourceGroup } =
    useRemoveResourceFromResourceGroup(group, {
      uuid: "",
    });
  const { addEveryoneToResourceGroup, isRequestPending } =
    useAddEveryoneToResourceGroup(group);

  return (
    <SelectList listClassName={styles.list} multiple>
      {() => ({
        input: <AddMemberIcon className={styles.icon} />,
        list: (
          <ResourceAllocationMenu
            allocatedResources={groupMembers.map(({ resource }) => resource)}
            select={(resources) => {
              resources.forEach(({ uuid }) => {
                const resourceToAdd = projectResources.find(
                  ({ resource }) => resource.uuid === uuid,
                );
                if (resourceToAdd) {
                  addResourceToResourceGroup({
                    group,
                    resource: resourceToAdd,
                  });
                }
              });
            }}
            unSelect={(resources) => {
              resources.forEach(({ uuid }) => {
                const resourceToRemove = projectResources.find(
                  ({ resource }) => resource.uuid === uuid,
                );
                if (resourceToRemove) {
                  removeResourceFromResourceGroup({
                    group,
                    resource: resourceToRemove,
                  });
                }
              });
            }}
            everyone={{
              select: () => addEveryoneToResourceGroup({ group, project }),
              isPending: isRequestPending,
            }}
            openedViews={["resources"]}
          />
        ),
      })}
    </SelectList>
  );
}

export { ProjectResourceSelect };
